var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$screen.mobile ? "p-home mobile-home" : "p-home" },
    [
      _c(
        "div",
        { staticClass: "page" },
        [
          _c("div", { attrs: { id: "topflag" } }),
          !_vm.$screen.mobile
            ? _c(
                "aside",
                { staticClass: "menu-box menu-box--vertical" },
                [
                  _c(
                    "el-menu",
                    {
                      staticClass: "el-menu-navItem el-menu--vertical",
                      attrs: {
                        "default-active": _vm.activeIndex,
                        "text-color": "#FFFFFF4D",
                        "active-text-color": "#706BF6",
                        mode: "vertical",
                        collapse: true,
                      },
                      on: { select: _vm.handleMenuSelect },
                    },
                    [
                      _vm._l(_vm.navsList, function (item, index) {
                        return [
                          item.children &&
                          item.children.length > 0 &&
                          item.isShowList &&
                          item.isShowList.length > 0 &&
                          item.location == "" &&
                          _vm.$canShowFeature(item.featureKey)
                            ? _c(
                                "el-submenu",
                                {
                                  key: index,
                                  attrs: {
                                    "popper-class": "adjust-submenu",
                                    index: item.index,
                                  },
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "title" },
                                    [
                                      _c("c-nav-svg", {
                                        attrs: {
                                          currentIndex: item.index,
                                          activeIndex: _vm.activeIndex,
                                        },
                                      }),
                                      _c("span", [_vm._v(_vm._s(item.text))]),
                                    ],
                                    1
                                  ),
                                  _vm._l(item.children, function (childItem) {
                                    return [
                                      childItem.children &&
                                      childItem.children.length > 0 &&
                                      childItem.isShowList &&
                                      childItem.isShowList.length > 0
                                        ? _c(
                                            "el-menu-item-group",
                                            {
                                              key: childItem.text,
                                              attrs: { index: childItem.index },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "title" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "NavItemfitstLevelText-item",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(childItem.text)
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._l(
                                                childItem.children,
                                                function (grandsonItem) {
                                                  return [
                                                    _vm.isNavItemVisible(
                                                      grandsonItem
                                                    )
                                                      ? _c(
                                                          "el-menu-item",
                                                          {
                                                            key: grandsonItem.text,
                                                            attrs: {
                                                              index:
                                                                grandsonItem.index,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                grandsonItem.text
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                }
                                              ),
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      (!childItem.children ||
                                        childItem.children.length == 0) &&
                                      _vm.isNavItemVisible(childItem)
                                        ? _c(
                                            "el-menu-item",
                                            {
                                              key: childItem.text,
                                              attrs: { index: childItem.index },
                                            },
                                            [_vm._v(_vm._s(childItem.text))]
                                          )
                                        : _vm._e(),
                                    ]
                                  }),
                                ],
                                2
                              )
                            : _vm._e(),
                          item.location != "" &&
                          _vm.$canShowFeature(item.featureKey)
                            ? _c(
                                "el-menu-item",
                                { key: index, attrs: { index: item.index } },
                                [
                                  _c("c-nav-svg", {
                                    attrs: {
                                      currentIndex: item.index,
                                      activeIndex: _vm.activeIndex,
                                    },
                                  }),
                                  _c("span", [_vm._v(_vm._s(item.text))]),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { class: _vm.$screen.mobile ? "page__main mobile" : "page__main" },
            [
              _c("header", { staticClass: "header-container" }, [
                !_vm.$screen.mobile
                  ? _c(
                      "div",
                      { staticClass: "header cyber-glow-border" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "logo-container",
                            attrs: { to: { name: "home" } },
                          },
                          [
                            _c("img", {
                              staticClass: "logo-new",
                              attrs: {
                                src: require("../../assets/images/logo.png"),
                                alt: "",
                              },
                            }),
                          ]
                        ),
                        _c("div", { staticClass: "user-box" }, [
                          _vm.user.nickname
                            ? _c(
                                "div",
                                { staticClass: "user-info-con" },
                                [
                                  _vm.aclList.indexOf("/recharge") == -1
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "btn-recharge",
                                          on: {
                                            click: function ($event) {
                                              return _vm.setPayModal(true)
                                            },
                                          },
                                        },
                                        [
                                          _c("Icon", {
                                            attrs: {
                                              type: "md-card",
                                              size: "18",
                                            },
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "text",
                                              staticStyle: {
                                                "margin-left": "5px",
                                              },
                                            },
                                            [_vm._v("充值")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c("div", { staticClass: "user-info" }, [
                                    _c(
                                      "div",
                                      { staticClass: "user-info-line" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "5px",
                                              width: "100%",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatName(
                                                  _vm.user.nickname
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "user-info-line" },
                                      [
                                        !_vm.showHappyCoinBalance &&
                                        !_vm.showCoin1Balance
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "balance",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.setPayModal(true)
                                                  },
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../assets/images/home_new/KJ_currency.png"),
                                                    width: "20",
                                                    height: "20",
                                                  },
                                                }),
                                                _c("c-number", {
                                                  attrs: {
                                                    from: 0,
                                                    to: _vm.user.balance,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        !_vm.showHappyCoinBalance &&
                                        !_vm.showCoin1Balance
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "balance",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.setPayModal(true)
                                                  },
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../assets/images/home_new/currency.png"),
                                                    width: "20",
                                                    height: "20",
                                                  },
                                                }),
                                                _c("c-number", {
                                                  attrs: {
                                                    from: 0,
                                                    to: _vm.user.recycles,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm.showHappyCoinBalance
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "balance",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.setPayModal(true)
                                                  },
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../assets/images/home_new/currency_hld.png"),
                                                    width: "18",
                                                    height: "18",
                                                  },
                                                }),
                                                _c("c-number", {
                                                  attrs: {
                                                    from: 0,
                                                    to: _vm.user.happyCoin,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm.showCoin1Balance
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "balance",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.setPayModal(true)
                                                  },
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../assets/images/home_new/jd_ico.png"),
                                                    width: "20",
                                                    height: "20",
                                                  },
                                                }),
                                                _c("c-number", {
                                                  attrs: {
                                                    from: 0,
                                                    to: _vm.user.coin1Available,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "avatar-con",
                                      attrs: { to: { name: "userinfo" } },
                                    },
                                    [
                                      _c("c-avatar", {
                                        attrs: {
                                          src: _vm.user.avatar,
                                          width: "100%",
                                          vip: _vm.user.vipLevel,
                                          is_streamer: _vm.user.isStreamer,
                                          curr_metal_url: _vm.user.currMetalUrl,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "drop-menu-icon",
                                      class: {
                                        active: _vm.user_drop_menu_show,
                                      },
                                      on: { click: _vm.openMenu },
                                    },
                                    [
                                      _c("div", { staticClass: "line" }),
                                      _c("div", { staticClass: "line" }),
                                      _c("div", { staticClass: "line" }),
                                      _c("div", { staticClass: "line" }),
                                    ]
                                  ),
                                  _c("c-dropmenu", { ref: "usermenu" }, [
                                    _c("ul", [
                                      _c(
                                        "li",
                                        { staticClass: "username" },
                                        [
                                          _c("c-avatar", {
                                            attrs: {
                                              src: _vm.user.avatar,
                                              width: "35px",
                                              vip: _vm.user.vipLevel,
                                              curr_metal_url:
                                                _vm.user.currMetalUrl,
                                            },
                                          }),
                                          _c("span", [
                                            _c("p", [
                                              _vm._v(_vm._s(_vm.user.nickname)),
                                            ]),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm.aclList.indexOf("/user/userInfo") ==
                                      -1
                                        ? _c(
                                            "li",
                                            {
                                              on: {
                                                click: function () {
                                                  _vm.openMenu()
                                                  _vm.pathGo({
                                                    name: "userinfo",
                                                  })
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "ivu-icon ivu-icon-md-person",
                                              }),
                                              _vm._v("个人中心 "),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.aclList.indexOf(
                                        "/user/ranks/rank/his"
                                      ) == -1
                                        ? _c(
                                            "li",
                                            {
                                              staticStyle: {
                                                position: "relative",
                                              },
                                              on: {
                                                click: function () {
                                                  _vm.pathGo({
                                                    name: "rankHis",
                                                    params: { rankHisType: 1 },
                                                  })
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "ivu-icon ivu-icon-ios-trophy",
                                              }),
                                              _vm._v("排行活动 "),
                                              _vm.hasRank
                                                ? _c("div", {
                                                    staticStyle: {
                                                      position: "absolute",
                                                      left: "88px",
                                                      top: "8px",
                                                      width: "6px",
                                                      height: "6px",
                                                      "border-radius": "6px",
                                                      "background-color":
                                                        "#827dff",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.aclList.indexOf("/user/inventory") ==
                                      -1
                                        ? _c(
                                            "li",
                                            {
                                              on: {
                                                click: function () {
                                                  _vm.openMenu()
                                                  _vm.pathGo({
                                                    name: "inventory",
                                                  })
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "ivu-icon ivu-icon-md-grid",
                                              }),
                                              _vm._v("我的背包 "),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.aclList.indexOf("/recharge") == -1
                                        ? _c(
                                            "li",
                                            {
                                              on: {
                                                click: function () {
                                                  _vm.openMenu()
                                                  _vm.setPayModal(true)
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "ivu-icon ivu-icon-md-card",
                                              }),
                                              _vm._v("在线充值 "),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "li",
                                        { on: { click: _vm.toggle_muted } },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "ivu-icon ivu-icon-md-radio",
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "margin-right": "12px",
                                              },
                                            },
                                            [_vm._v("声音")]
                                          ),
                                          _vm._v(
                                            _vm._s(!_vm.isMute ? "开" : "关") +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function () {
                                              _vm.logOut()
                                              _vm.openMenu()
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "ivu-icon ivu-icon-md-exit",
                                          }),
                                          _vm._v("退出登录 "),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ],
                                1
                              )
                            : _c("div", { staticClass: "login-box" }, [
                                _vm.showLogin
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "login-btn",
                                        on: {
                                          click: function () {
                                            _vm.loginModal.active = "sign_in"
                                            _vm.setloginModal(true)
                                          },
                                        },
                                      },
                                      [_vm._v(" 登录 ")]
                                    )
                                  : _vm._e(),
                                _vm.showRegister
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "login-btn reg",
                                        on: {
                                          click: function () {
                                            _vm.loginModal.active =
                                              "register_mobile"
                                            _vm.setloginModal(true)
                                          },
                                        },
                                      },
                                      [
                                        _c("c-svg", {
                                          staticClass: "icon",
                                          attrs: {
                                            src: "reg1.svg",
                                            width: "16",
                                            height: "16",
                                            fill: "#000",
                                          },
                                        }),
                                        _c("div", { staticClass: "line" }),
                                        _vm._v(" 注册 "),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.$screen.mobile
                  ? _c("div", { staticClass: "header" }, [
                      _c(
                        "div",
                        { staticClass: "menu-mobile-box flex" },
                        [
                          _vm._l(_vm.navsList, function (item, index) {
                            return [
                              _vm.$canShowFeature(item.featureKey)
                                ? _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass:
                                        "menu-mobile-box-item flex flex-center-1",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "menu-mobile-box-item-title flex flex-col flex-center-1",
                                          class: {
                                            "menu-mobile-box-item-title-active":
                                              _vm.parentIndex == item.index ||
                                              _vm.lastResultIndex == item.index,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onBottomTabHandle(item)
                                            },
                                          },
                                        },
                                        [
                                          _c("c-nav-svg", {
                                            attrs: {
                                              currentIndex: item.index,
                                              activeIndex:
                                                _vm.parentIndex ||
                                                _vm.lastResultIndex,
                                            },
                                          }),
                                          _c("span", [
                                            _vm._v(_vm._s(item.text)),
                                          ]),
                                        ],
                                        1
                                      ),
                                      item.children &&
                                      item.children.length > 0 &&
                                      item.location == "" &&
                                      _vm.parentIndex == item.index
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "menu-mobile-box-item-menuList animate__animated animate__fadeIn animate__faster",
                                              class: {
                                                firstDiv: index == 0,
                                                lastDiv:
                                                  index ==
                                                  _vm.navsList.length - 1,
                                              },
                                            },
                                            _vm._l(
                                              item.children,
                                              function (childrenItem) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: childrenItem.index,
                                                    staticClass:
                                                      "menuList-item",
                                                  },
                                                  [
                                                    childrenItem.children &&
                                                    childrenItem.children
                                                      .length > 0 &&
                                                    childrenItem.isShowList &&
                                                    childrenItem.isShowList
                                                      .length > 0
                                                      ? [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "menuList-item-second-title flex flex-ver",
                                                            },
                                                            [
                                                              childrenItem.icon
                                                                ? _c("div", {
                                                                    staticClass:
                                                                      "icon",
                                                                    style: {
                                                                      backgroundImage:
                                                                        "url(" +
                                                                        childrenItem.icon +
                                                                        ")",
                                                                    },
                                                                  })
                                                                : _vm._e(),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    childrenItem.text
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "menuList-item-children",
                                                            },
                                                            [
                                                              _vm._l(
                                                                childrenItem.children,
                                                                function (
                                                                  grandsonItem
                                                                ) {
                                                                  return [
                                                                    _vm.isNavItemVisible(
                                                                      grandsonItem
                                                                    )
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            key: grandsonItem.index,
                                                                            staticClass:
                                                                              "menuList-item-third-title flex flex-center-1",
                                                                            class:
                                                                              {
                                                                                "menuList-item-third-title-active":
                                                                                  _vm.activeIndex ==
                                                                                  grandsonItem.index,
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.handleMenuSelect(
                                                                                    grandsonItem.index
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            grandsonItem.icon
                                                                              ? _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "icon",
                                                                                    style:
                                                                                      {
                                                                                        backgroundImage:
                                                                                          "url(" +
                                                                                          grandsonItem.icon +
                                                                                          ")",
                                                                                      },
                                                                                  }
                                                                                )
                                                                              : _vm._e(),
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                grandsonItem.text
                                                                              ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                }
                                                              ),
                                                            ],
                                                            2
                                                          ),
                                                        ]
                                                      : _vm._e(),
                                                    !childrenItem.children ||
                                                    (childrenItem.children &&
                                                      childrenItem.children
                                                        .length == 0)
                                                      ? [
                                                          _vm.isNavItemVisible(
                                                            childrenItem
                                                          )
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "menuList-item-third-title flex flex-center-1",
                                                                  class: {
                                                                    "menuList-item-third-title-active":
                                                                      _vm.activeIndex ==
                                                                      childrenItem.index,
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleMenuSelect(
                                                                          childrenItem.index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  childrenItem.icon
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "icon",
                                                                          style:
                                                                            {
                                                                              backgroundImage:
                                                                                "url(" +
                                                                                childrenItem.icon +
                                                                                ")",
                                                                            },
                                                                        }
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      childrenItem.text
                                                                    ) + " "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      : _vm._e(),
                                                  ],
                                                  2
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          }),
                        ],
                        2
                      ),
                      _c(
                        "div",
                        { staticClass: "user-box" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "logo-container",
                              attrs: { to: { name: "home" } },
                            },
                            [
                              _c("img", {
                                staticClass: "logo-new",
                                attrs: {
                                  src: require("../../assets/images/logo.png"),
                                  alt: "",
                                },
                              }),
                            ]
                          ),
                          _vm.user.nickname
                            ? _c(
                                "div",
                                { staticClass: "user-info-con" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "avatar-con",
                                      on: { click: _vm.openMenu },
                                    },
                                    [
                                      _c("c-avatar", {
                                        attrs: {
                                          src: _vm.user.avatar,
                                          width: "100%",
                                          vip: _vm.user.vipLevel,
                                          is_streamer: _vm.user.isStreamer,
                                          curr_metal_url: _vm.user.currMetalUrl,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "user-info" }, [
                                    _c(
                                      "div",
                                      { staticClass: "user-info-line" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "5px",
                                              width: "100%",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatName(
                                                  _vm.user.nickname
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "user-info-line" },
                                      [
                                        !_vm.showHappyCoinBalance &&
                                        !_vm.showCoin1Balance
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "balance",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.setPayModal(true)
                                                  },
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../assets/images/home_new/KJ_currency.png"),
                                                    width: "20",
                                                    height: "20",
                                                  },
                                                }),
                                                _c("c-number", {
                                                  attrs: {
                                                    from: 0,
                                                    to: _vm.user.balance,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        !_vm.showHappyCoinBalance &&
                                        !_vm.showCoin1Balance
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "balance",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.setPayModal(true)
                                                  },
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../assets/images/home_new/currency.png"),
                                                    width: "20",
                                                    height: "20",
                                                  },
                                                }),
                                                _c("c-number", {
                                                  attrs: {
                                                    from: 0,
                                                    to: _vm.user.recycles,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm.showHappyCoinBalance
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "balance",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.setPayModal(true)
                                                  },
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../assets/images/home_new/currency_hld.png"),
                                                    width: "18",
                                                    height: "18",
                                                  },
                                                }),
                                                _c("c-number", {
                                                  attrs: {
                                                    from: 0,
                                                    to: _vm.user.happyCoin,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm.showCoin1Balance
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "balance",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.setPayModal(true)
                                                  },
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../assets/images/home_new/jd_ico.png"),
                                                    width: "20",
                                                    height: "20",
                                                  },
                                                }),
                                                _c("c-number", {
                                                  attrs: {
                                                    from: 0,
                                                    to: _vm.user.coin1Available,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "c-dropmenu",
                                    {
                                      ref: "usermenu",
                                      on: {
                                        onCloseDropMenuHandle:
                                          _vm.onCloseDropMenuHandle,
                                      },
                                    },
                                    [
                                      _c("ul", [
                                        _c(
                                          "li",
                                          { staticClass: "username" },
                                          [
                                            _c("c-avatar", {
                                              attrs: {
                                                src: _vm.user.avatar,
                                                width: "35px",
                                                vip: _vm.user.vipLevel,
                                                curr_metal_url:
                                                  _vm.user.currMetalUrl,
                                              },
                                            }),
                                            _c("span", [
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(_vm.user.nickname)
                                                ),
                                              ]),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _vm.aclList.indexOf("/user/userInfo") ==
                                        -1
                                          ? _c(
                                              "li",
                                              {
                                                on: {
                                                  click: function () {
                                                    _vm.openMenu()
                                                    _vm.pathGo({
                                                      name: "userinfo",
                                                    })
                                                  },
                                                },
                                              },
                                              [_vm._v(" 个人中心 ")]
                                            )
                                          : _vm._e(),
                                        _vm.aclList.indexOf(
                                          "/user/ranks/rank/his"
                                        ) == -1
                                          ? _c(
                                              "li",
                                              {
                                                staticStyle: {
                                                  position: "relative",
                                                },
                                                on: {
                                                  click: function () {
                                                    _vm.pathGo({
                                                      name: "rankHis",
                                                      params: {
                                                        rankHisType: 1,
                                                      },
                                                    })
                                                  },
                                                },
                                              },
                                              [_vm._v(" 排行活动 ")]
                                            )
                                          : _vm._e(),
                                        _vm.aclList.indexOf(
                                          "/user/inventory"
                                        ) == -1
                                          ? _c(
                                              "li",
                                              {
                                                on: {
                                                  click: function () {
                                                    _vm.openMenu()
                                                    _vm.pathGo({
                                                      name: "inventory",
                                                    })
                                                  },
                                                },
                                              },
                                              [_vm._v(" 我的背包 ")]
                                            )
                                          : _vm._e(),
                                        _vm.aclList.indexOf("/recharge") == -1
                                          ? _c(
                                              "li",
                                              {
                                                on: {
                                                  click: function () {
                                                    _vm.openMenu()
                                                    _vm.setPayModal(true)
                                                  },
                                                },
                                              },
                                              [_vm._v(" 在线充值 ")]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "li",
                                          { on: { click: _vm.toggle_muted } },
                                          [
                                            _vm._v(
                                              " 声音 " +
                                                _vm._s(
                                                  !_vm.isMute ? "开" : "关"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "li",
                                          {
                                            on: {
                                              click: function () {
                                                _vm.logOut()
                                                _vm.openMenu()
                                              },
                                            },
                                          },
                                          [_vm._v(" 退出登录 ")]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _c("div", { staticClass: "login-box" }, [
                                _vm.showLogin
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "login-btn",
                                        on: {
                                          click: function () {
                                            _vm.loginModal.active = "sign_in"
                                            _vm.setloginModal(true)
                                          },
                                        },
                                      },
                                      [_vm._v(" 登录 ")]
                                    )
                                  : _vm._e(),
                                _vm.showRegister
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "login-btn reg",
                                        on: {
                                          click: function () {
                                            _vm.loginModal.active =
                                              "register_mobile"
                                            _vm.setloginModal(true)
                                          },
                                        },
                                      },
                                      [
                                        _c("c-svg", {
                                          staticClass: "icon",
                                          attrs: {
                                            src: "reg1.svg",
                                            width: "16",
                                            height: "16",
                                            fill: "#000",
                                          },
                                        }),
                                        _c("div", { staticClass: "line" }),
                                        _c("div", { staticClass: "line" }),
                                        _vm._v(" 注册 "),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm.isShowQQ &&
              _vm.$screen.mobile &&
              _vm.GobalInfo.GroupLink &&
              _vm.aclList.indexOf("/group") == -1 &&
              _vm.path == "home"
                ? _c("div", { staticClass: "qq-top" }, [
                    _c("img", {
                      staticClass: "closeIcon",
                      attrs: {
                        src: require("../../assets/icons/whiteClose.png"),
                        alt: "",
                      },
                      on: {
                        click: function ($event) {
                          _vm.isShowQQ = false
                        },
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "qq-top-item flex flex-col flex-center-1",
                        on: { click: _vm.onGotoQQHandle },
                      },
                      [
                        _c("img", {
                          staticClass: "qqIcon",
                          attrs: {
                            src: require("../../assets/icons/qq.png"),
                            alt: "",
                          },
                        }),
                        _c("span", { staticClass: "qq-top__label" }, [
                          _vm._v("添加QQ群"),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "mainContentItem flex" }, [
                _c(
                  "div",
                  {
                    staticClass: "main-content flex",
                    class: {
                      "main-content--no-livedrop":
                        _vm.path === "home" && !_vm.isShowLiveDrop,
                    },
                  },
                  [
                    _c(
                      "keep-alive",
                      [
                        _vm.isRouterAlive &&
                        _vm.$route.matched[1] &&
                        _vm.$route.matched[1].meta.keepAlive
                          ? _c("router-view")
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm.isRouterAlive &&
                    (!_vm.$route.matched[1] ||
                      !_vm.$route.matched[1].meta.keepAlive)
                      ? _c("router-view")
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _c("footer", { staticClass: "footer" }, [
                _c("div", { staticClass: "partner" }, [
                  _vm._m(0),
                  _c(
                    "div",
                    { staticClass: "partner-logo" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "link-item",
                          attrs: { to: { name: "agreement" } },
                        },
                        [_vm._v("最终用户许可协议")]
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass: "link-item",
                          attrs: { to: { name: "privacy" } },
                        },
                        [_vm._v("隐私策略")]
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass: "link-item",
                          attrs: { to: { name: "clause" } },
                        },
                        [_vm._v("条款和条件")]
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass: "link-item",
                          attrs: { to: { name: "aboutUs" } },
                        },
                        [_vm._v("关于我们")]
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass: "link-item",
                          attrs: { to: { name: "faq" } },
                        },
                        [_vm._v("常见问题")]
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass: "link-item",
                          attrs: { to: { name: "faq" } },
                        },
                        [_vm._v("FAQ")]
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass: "link-item",
                          attrs: { to: { name: "aboutUs" } },
                        },
                        [_vm._v("联系我们")]
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "partner" }, [
                  _c("div", { staticClass: "link-con" }, [
                    _c("span", { staticClass: "desc-text" }, [
                      _vm._v("©2023 - " + _vm._s(_vm.currentYear) + " KJcs2"),
                    ]),
                  ]),
                  _vm._m(1),
                ]),
              ]),
            ]
          ),
          _vm.mobile_sidebar_left_show || _vm.mobile_sidebar_right_show
            ? _c("div", {
                staticClass: "nav_left_shadow",
                on: {
                  click: function ($event) {
                    ;(_vm.mobile_sidebar_left_show = false),
                      (_vm.mobile_sidebar_right_show = false)
                  },
                },
              })
            : _vm._e(),
          _vm.user.nickname
            ? _c(
                "div",
                {
                  class: [
                    "page_nav_right",
                    _vm.mobile_sidebar_right_show ? "active" : "",
                  ],
                  staticStyle: { display: "none" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "index_nav_right_user" },
                    [
                      _c("c-avatar", {
                        attrs: {
                          src: _vm.user.avatar,
                          width: "20%",
                          vip: _vm.user.vipLevel,
                          curr_metal_url: _vm.user.currMetalUrl,
                        },
                      }),
                      _c("p", { staticClass: "name" }, [
                        _vm._v(_vm._s(_vm.user.nickname)),
                      ]),
                      _c("span", { staticClass: "id" }, [
                        _vm._v("用户ID：" + _vm._s(_vm.user.id)),
                      ]),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "index_nav_user_num" }, [
                    _c("div", { staticClass: "money" }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/images/icon/bill-icon.png"),
                          alt: "",
                        },
                      }),
                      _c("p", [
                        _vm._v(_vm._s(_vm._f("conversion")(_vm.user.balance))),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "index_nav_right_button" },
                    [
                      _c(
                        "c-button",
                        {
                          staticClass: "submit-button",
                          attrs: {
                            type: "pure",
                            theme: "pink",
                            width: "80%",
                            margin: "8% auto",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.setPayModal(true)
                            },
                          },
                        },
                        [_vm._v("点击充值")]
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "index_nav_right_list" }, [
                    _c("ul", [
                      _c(
                        "li",
                        {
                          class: [
                            "userCenter",
                            _vm.$route.name === "userinfo" ? "active" : "",
                          ],
                        },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: { name: "userinfo" } } },
                            [_vm._v("个人中心")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _c(
                    "p",
                    {
                      staticClass: "index_nav_right_logout",
                      on: { click: _vm.logOut },
                    },
                    [
                      _c("a", { attrs: { href: "javascript:" } }, [
                        _vm._v("退出登录"),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _c("p-sidebar", {
            staticClass: "page__sidebar",
            on: { on_welfareclick: _vm.openWelfareModal },
          }),
          _c(
            "Modal",
            {
              attrs: {
                "class-name": "design-modal app-modal loginItems",
                "footer-hide": "",
                width: "'400rem'",
                closable: false,
              },
              on: {
                "on-cancel": _vm.loginClose,
                "on-visible-change": _vm.loginClose,
              },
              model: {
                value: _vm.loginModal.flag,
                callback: function ($$v) {
                  _vm.$set(_vm.loginModal, "flag", $$v)
                },
                expression: "loginModal.flag",
              },
            },
            [
              _c(
                "c-interactive-panel",
                {
                  staticClass: "sign-up",
                  attrs: { has_close_button: "" },
                  on: {
                    close_button_click: function () {
                      _vm.loginModal.flag = false
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _vm.loginModal.active != "forget"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "sign-up__footer flex flex-ver flex-jcfe",
                                },
                                [
                                  _vm.loginModal.active === "sign_in"
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "sign-up__toggle",
                                          on: {
                                            click: function () {
                                              return (_vm.loginModal.active =
                                                "forget")
                                            },
                                          },
                                        },
                                        [_vm._v("忘记密码")]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                          _vm.loginModal.active === "forget"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "sign-up__footer flex flex-ver flex-jcfe",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "sign-up__toggle",
                                      on: {
                                        click: function () {
                                          return (_vm.loginModal.active =
                                            "sign_in")
                                        },
                                      },
                                    },
                                    [_vm._v("返回登录")]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("div", { staticClass: "sign-up-logo" }, [
                    _c("img", {
                      staticClass: "logo-new",
                      attrs: {
                        src: require("../../assets/images/logo.png"),
                        alt: "",
                      },
                    }),
                  ]),
                  _vm.loginModal.active == "sign_in"
                    ? _c("h1", { staticClass: "sign-up-title" }, [
                        _vm._v(" 平台登录 "),
                      ])
                    : _vm._e(),
                  _vm.loginModal.active == "register_mobile"
                    ? _c("h1", { staticClass: "sign-up-title" }, [
                        _vm._v(" 用户注册 "),
                      ])
                    : _vm._e(),
                  _vm.loginModal.active == "forget"
                    ? _c("h1", { staticClass: "sign-up-title" }, [
                        _vm._v(" 找回密码 "),
                      ])
                    : _vm._e(),
                  _vm.loginModal.active === "sign_in"
                    ? _c("div", { staticClass: "sign-up__content" }, [
                        _c("label", { staticClass: "sign-up__field" }, [
                          _c("div", { staticClass: "icon_input" }, [
                            _c("i", {
                              staticClass:
                                "ivu-icon ivu-icon ivu-icon-ios-call-outline",
                              staticStyle: { "font-size": "20px" },
                            }),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.loginModal.from.email,
                                  expression: "loginModal.from.email",
                                },
                              ],
                              staticClass: "sign-up__field__input pad50",
                              attrs: {
                                type: "text",
                                placeholder: "手机号/邮箱",
                                autocomplete: "off",
                              },
                              domProps: { value: _vm.loginModal.from.email },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.loginModal.from,
                                    "email",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c("label", { staticClass: "sign-up__field" }, [
                          _c("div", { staticClass: "icon_input" }, [
                            _c("i", {
                              staticClass: "ivu-icon ivu-icon-ios-lock-outline",
                              staticStyle: { "font-size": "20px" },
                            }),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.loginModal.from.password,
                                  expression: "loginModal.from.password",
                                },
                              ],
                              staticClass: "sign-up__field__input pad50",
                              attrs: {
                                type: "password",
                                placeholder: "请输入密码",
                                autocomplete: "off",
                              },
                              domProps: { value: _vm.loginModal.from.password },
                              on: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.sessionLoginPost(
                                    _vm.loginModal.from
                                  )
                                },
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.loginModal.from,
                                    "password",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "sign-up__submit_item flex flex-center-1",
                          },
                          [
                            _vm.isSubmit
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "submit-button flex flex-center-1",
                                  },
                                  [
                                    _c("c-loading-scope", {
                                      staticClass: "submit-button-loading",
                                    }),
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "submit-button flex flex-center-1",
                                    on: {
                                      click: function ($event) {
                                        return _vm.sessionLoginPost(
                                          _vm.loginModal.from
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" 立即登录 ")]
                                ),
                          ]
                        ),
                        _vm.loginModal.active != "forget"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "sign-up__footer flex flex-center-1",
                                staticStyle: { "margin-top": "10px" },
                              },
                              [
                                _c(
                                  "label",
                                  { staticClass: "sign-up__agreement" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.loginModal.from.agree,
                                          expression: "loginModal.from.agree",
                                        },
                                      ],
                                      staticClass: "sign-up__agreement__value",
                                      attrs: { type: "checkbox", hidden: "" },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.loginModal.from.agree
                                        )
                                          ? _vm._i(
                                              _vm.loginModal.from.agree,
                                              null
                                            ) > -1
                                          : _vm.loginModal.from.agree,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = _vm.loginModal.from.agree,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.loginModal.from,
                                                  "agree",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.loginModal.from,
                                                  "agree",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.loginModal.from,
                                              "agree",
                                              $$c
                                            )
                                          }
                                        },
                                      },
                                    }),
                                    _c("span", {
                                      staticClass:
                                        "sign-up__agreement__checkbox",
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "sign-up__agreement__text",
                                      },
                                      [
                                        _vm._v("确认已满18岁，并同意 "),
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: { name: "agreement" },
                                            },
                                          },
                                          [_c("span", [_vm._v("用户协议")])]
                                        ),
                                        _vm._v(" & "),
                                        _c(
                                          "router-link",
                                          {
                                            attrs: { to: { name: "privacy" } },
                                          },
                                          [_c("span", [_vm._v("隐私条款")])]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass:
                              "sign-up__other_way_item flex flex-col flex-center-1",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "regist-item flex flex-ver" },
                              [
                                _c("p", { staticClass: "regist-item-title" }, [
                                  _vm._v("还未有账号?"),
                                ]),
                                _c(
                                  "p",
                                  {
                                    staticClass: "registItems-item",
                                    on: {
                                      click: function ($event) {
                                        _vm.loginModal.active =
                                          "register_mobile"
                                      },
                                    },
                                  },
                                  [_vm._v(" 去注册 ")]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm.loginModal.active === "register_mobile"
                    ? _c("div", { staticClass: "sign-up__content" }, [
                        _c("label", { staticClass: "sign-up__field" }, [
                          _c("div", { staticClass: "icon_input" }, [
                            _c("i", {
                              staticClass:
                                "ivu-icon ivu-icon ivu-icon-ios-call-outline",
                              staticStyle: { "font-size": "20px" },
                            }),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.modal.mobileSignData.phone,
                                  expression: "modal.mobileSignData.phone",
                                },
                              ],
                              staticClass: "sign-up__field__input pad50",
                              attrs: {
                                type: "tel",
                                maxlength: "11",
                                placeholder: "手机号/邮箱",
                              },
                              domProps: {
                                value: _vm.modal.mobileSignData.phone,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.modal.mobileSignData,
                                    "phone",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c("label", { staticClass: "sign-up__field" }, [
                          _c("div", { staticClass: "icon_input" }, [
                            _c("i", {
                              staticClass: "ivu-icon ivu-icon-ios-lock-outline",
                              staticStyle: { "font-size": "20px" },
                            }),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.modal.mobileSignData.password,
                                  expression: "modal.mobileSignData.password",
                                },
                              ],
                              staticClass: "sign-up__field__input pad50",
                              attrs: {
                                type: "password",
                                placeholder: "请输入密码",
                                autocomplete: "off",
                              },
                              domProps: {
                                value: _vm.modal.mobileSignData.password,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.modal.mobileSignData,
                                    "password",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c("label", { staticClass: "sign-up__field" }, [
                          _c("div", { staticClass: "vcode_input" }, [
                            _c("i", {
                              staticClass:
                                "ivu-icon ivu-icon-ios-chatboxes-outline",
                              staticStyle: { "font-size": "20px" },
                            }),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.modal.mobileSignData.code,
                                  expression: "modal.mobileSignData.code",
                                },
                              ],
                              staticClass: "sign-up__field__input",
                              attrs: {
                                type: "text",
                                inputmode: "numeric",
                                placeholder: "请输入验证码",
                              },
                              domProps: {
                                value: _vm.modal.mobileSignData.code,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.modal.mobileSignData,
                                    "code",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c(
                              "button",
                              {
                                staticClass: "sign-up__field__action",
                                attrs: {
                                  disabled:
                                    _vm.modal.mobileSignData.time !== 61,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.getMobileCode(
                                      "sendMobileCode",
                                      _vm.modal.mobileSignData
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.modal.mobileSignData.time === 61
                                        ? "获取验证码"
                                        : "等待" +
                                            _vm.modal.resetWithPhone.time +
                                            "秒"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                        _c("label", { staticClass: "sign-up__field" }, [
                          _c("div", { staticClass: "icon_input" }, [
                            _c("i", {
                              staticClass: "ivu-icon ivu-icon-md-share",
                              staticStyle: { "font-size": "20px" },
                            }),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.loginModal.from.inviteD,
                                  expression: "loginModal.from.inviteD",
                                },
                              ],
                              staticClass: "sign-up__field__input pad50",
                              attrs: {
                                type: "text",
                                placeholder: "邀请码(选填)",
                              },
                              domProps: { value: _vm.loginModal.from.inviteD },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.loginModal.from,
                                    "inviteD",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "sign-up__submit_item flex flex-center-1",
                          },
                          [
                            _vm.isSubmit
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "submit-button flex flex-center-1",
                                  },
                                  [
                                    _c("c-loading-scope", {
                                      staticClass: "submit-button-loading",
                                    }),
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "submit-button flex flex-center-1",
                                    on: { click: _vm.mobileRegister },
                                  },
                                  [_vm._v(" 确认注册 ")]
                                ),
                          ]
                        ),
                        _vm.loginModal.active != "forget"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "sign-up__footer flex flex-center-1",
                                staticStyle: { "margin-top": "10px" },
                              },
                              [
                                _c(
                                  "label",
                                  { staticClass: "sign-up__agreement" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.loginModal.from.agree,
                                          expression: "loginModal.from.agree",
                                        },
                                      ],
                                      staticClass: "sign-up__agreement__value",
                                      attrs: { type: "checkbox", hidden: "" },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.loginModal.from.agree
                                        )
                                          ? _vm._i(
                                              _vm.loginModal.from.agree,
                                              null
                                            ) > -1
                                          : _vm.loginModal.from.agree,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = _vm.loginModal.from.agree,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.loginModal.from,
                                                  "agree",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.loginModal.from,
                                                  "agree",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.loginModal.from,
                                              "agree",
                                              $$c
                                            )
                                          }
                                        },
                                      },
                                    }),
                                    _c("span", {
                                      staticClass:
                                        "sign-up__agreement__checkbox",
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "sign-up__agreement__text",
                                      },
                                      [
                                        _vm._v("确认已满18岁，并同意 "),
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: { name: "agreement" },
                                            },
                                          },
                                          [_c("span", [_vm._v("用户协议")])]
                                        ),
                                        _vm._v(" & "),
                                        _c(
                                          "router-link",
                                          {
                                            attrs: { to: { name: "privacy" } },
                                          },
                                          [_c("span", [_vm._v("隐私条款")])]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass:
                              "sign-up__other_way_item flex flex-col flex-center-1",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "flex flex-center-1",
                                staticStyle: { "margin-bottom": "5px" },
                              },
                              [
                                _c("div", {
                                  staticClass: "lineBlock flex flex-center-1",
                                }),
                                _c("p", [_vm._v("或者使用")]),
                                _c("div", {
                                  staticClass: "lineBlock flex flex-center-1",
                                }),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "other_way_itemList flex flex-ver",
                              },
                              _vm._l(
                                _vm.otherLoginList,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass:
                                        "other_way_item flex flex-center-1",
                                      on: {
                                        click: function ($event) {
                                          return _vm.onAuthorizedLoginHanlde(
                                            item
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("img", {
                                        attrs: { src: item.icon, alt: "" },
                                      }),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                            _c(
                              "div",
                              { staticClass: "regist-item flex flex-ver" },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass: "registItems-item",
                                    on: {
                                      click: function ($event) {
                                        _vm.loginModal.active = "sign_in"
                                      },
                                    },
                                  },
                                  [_vm._v(" 去登录 ")]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm.loginModal.active === "forget"
                    ? _c("div", { staticClass: "sign-up__content" }, [
                        _c("label", { staticClass: "sign-up__field" }, [
                          _c("div", { staticClass: "icon_input" }, [
                            _c("i", {
                              staticClass:
                                "ivu-icon ivu-icon ivu-icon-ios-call-outline",
                              staticStyle: { "font-size": "20px" },
                            }),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.modal.resetWithPhone.phone,
                                  expression: "modal.resetWithPhone.phone",
                                },
                              ],
                              staticClass: "sign-up__field__input pad50",
                              attrs: {
                                type: "text",
                                placeholder: "手机号/邮箱",
                              },
                              domProps: {
                                value: _vm.modal.resetWithPhone.phone,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.modal.resetWithPhone,
                                    "phone",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c("label", { staticClass: "sign-up__field" }, [
                          _c("div", { staticClass: "icon_input" }, [
                            _c("i", {
                              staticClass: "ivu-icon ivu-icon-ios-lock-outline",
                              staticStyle: { "font-size": "20px" },
                            }),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.modal.resetWithPhone.password,
                                  expression: "modal.resetWithPhone.password",
                                },
                              ],
                              staticClass: "sign-up__field__input pad50",
                              attrs: {
                                type: "password",
                                placeholder: "请输入密码",
                                autocomplete: "off",
                              },
                              domProps: {
                                value: _vm.modal.resetWithPhone.password,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.modal.resetWithPhone,
                                    "password",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c("label", { staticClass: "sign-up__field" }, [
                          _c("div", { staticClass: "vcode_input" }, [
                            _c("i", {
                              staticClass:
                                "ivu-icon ivu-icon-ios-chatboxes-outline",
                              staticStyle: { "font-size": "20px" },
                            }),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.modal.resetWithPhone.code,
                                  expression: "modal.resetWithPhone.code",
                                },
                              ],
                              staticClass: "sign-up__field__input",
                              attrs: {
                                type: "text",
                                inputmode: "numeric",
                                placeholder: "请输入验证码",
                              },
                              domProps: {
                                value: _vm.modal.resetWithPhone.code,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.modal.resetWithPhone,
                                    "code",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c(
                              "button",
                              {
                                staticClass: "sign-up__field__action",
                                attrs: {
                                  disabled:
                                    _vm.modal.resetWithPhone.time !== 61,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.getMobileCode(
                                      "sendResetCode",
                                      _vm.modal.resetWithPhone
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.modal.resetWithPhone.time === 61
                                        ? "获取验证码"
                                        : "等待" +
                                            _vm.modal.resetWithPhone.time +
                                            "秒"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "sign-up__submit_item flex flex-center-1",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "submit-button flex flex-center-1",
                                on: { click: _vm.reset_sign_in_password },
                              },
                              [_vm._v(" 重置密码 ")]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
          _c(
            "Modal",
            {
              attrs: {
                "class-name": "app-modal",
                "footer-hide": "",
                width: "'600rem'",
                closable: false,
              },
              on: {
                "on-cancel": function ($event) {
                  _vm.PayModal.flag = false
                },
              },
              model: {
                value: _vm.PayModal.flag,
                callback: function ($$v) {
                  _vm.$set(_vm.PayModal, "flag", $$v)
                },
                expression: "PayModal.flag",
              },
            },
            [
              _vm.user.nickname && _vm.PayModal.flag
                ? _c(
                    "c-interactive-panel",
                    {
                      attrs: {
                        title: "储值余额 RECHARGE",
                        has_close_button: "",
                      },
                      on: {
                        close_button_click: function () {
                          _vm.PayModal.flag = false
                        },
                      },
                    },
                    [_c("p-recharge")],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "Modal",
            {
              attrs: {
                "class-name": "app-modal",
                "footer-hide": "",
                width: "'438rem'",
                closable: false,
              },
              on: {
                "on-cancel": function ($event) {
                  _vm.RedPacketModal.flag = false
                },
              },
              model: {
                value: _vm.RedPacketModal.flag,
                callback: function ($$v) {
                  _vm.$set(_vm.RedPacketModal, "flag", $$v)
                },
                expression: "RedPacketModal.flag",
              },
            },
            [
              _vm.user.nickname && _vm.RedPacketModal.flag
                ? _c(
                    "c-interactive-panel",
                    {
                      attrs: { has_close_button: "" },
                      on: {
                        close_button_click: function () {
                          _vm.RedPacketModal.flag = false
                        },
                      },
                    },
                    [_c("p-red-packet")],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "Modal",
            {
              attrs: {
                "class-name": "app-modal",
                "footer-hide": "",
                width: "'438rem'",
                closable: false,
              },
              on: {
                "on-cancel": function ($event) {
                  _vm.PayModal.idflag = false
                },
              },
              model: {
                value: _vm.PayModal.idflag,
                callback: function ($$v) {
                  _vm.$set(_vm.PayModal, "idflag", $$v)
                },
                expression: "PayModal.idflag",
              },
            },
            [
              _vm.user.nickname
                ? _c(
                    "c-interactive-panel",
                    {
                      attrs: {
                        title: "确保您为已满18岁,请通过实名认证",
                        has_close_button: "",
                      },
                      on: {
                        close_button_click: function () {
                          _vm.PayModal.idflag = false
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "sign-up__content" }, [
                        _c("label", { staticClass: "sign-up__field" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.modal.bindIdCard,
                                expression: "modal.bindIdCard",
                              },
                            ],
                            staticClass: "sign-up__field__input",
                            attrs: {
                              type: "text",
                              placeholder: "请输入身份证号",
                            },
                            domProps: { value: _vm.modal.bindIdCard },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.modal,
                                  "bindIdCard",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "submit-button",
                            staticStyle: { width: "100%" },
                            on: { click: _vm.bind_idcard },
                          },
                          [_vm._v(" 确认提交 ")]
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "Modal",
            {
              attrs: {
                "class-name": "app-modal",
                "footer-hide": "",
                width: "'1250rem'",
                closable: false,
              },
              model: {
                value: _vm.welfareCenterFlag,
                callback: function ($$v) {
                  _vm.welfareCenterFlag = $$v
                },
                expression: "welfareCenterFlag",
              },
            },
            [
              _c("c-welfareCenter", {
                attrs: { welfareCat: _vm.welfareCat },
                on: {
                  "update:welfareCat": function ($event) {
                    _vm.welfareCat = $event
                  },
                  "update:welfare-cat": function ($event) {
                    _vm.welfareCat = $event
                  },
                  close_button_click: function () {
                    return (_vm.welfareCenterFlag = false)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.$canShowFeature("multiple_people_case")
        ? _c("c-notification-card", {
            attrs: {
              visible: _vm.showMpCaseNotification,
              "session-data": _vm.curMpCaseData,
            },
            on: {
              "update:visible": function ($event) {
                _vm.showMpCaseNotification = $event
              },
              join: _vm.onMPCasePlayerJoin,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "link-con" }, [
      _c("a", { staticClass: "logo-con", attrs: { href: "/" } }, [
        _c("img", {
          staticClass: "logo-new",
          attrs: {
            src: require("../../assets/images/logo.png"),
            height: "40",
            alt: "",
          },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "partner-logo" }, [
      _c("span", { staticClass: "desc-text" }, [
        _vm._v(
          "您提供的个人信息（姓名、地址、电话、电子邮件、信用卡号）是保密的，不得披露。您的银行卡详细信息仅以加密形式传输，不会存储在我们的网络服务器上。所有使用支付卡的操作均按照Visa国际和万事达卡全球的要求进行"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }